module.exports = __webpack_public_path__ + "static/img/passo2.32a01c5d.svg";